import { Row, Col } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const UserMutateFormTemplate = () => {
  return (
    <Row>
      <Col xs={12}>
        <CrudPlaceholderInput name="name" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput name="username" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput name="email" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput password={true} name="password" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput password={true} name="password_confirmation" />
      </Col>
    </Row>
  );
};
